import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type PayrollExpenseFormAnalyticIds = {
  ticketingProviderUsersAnalyticId: string;
  nameAnalyticId: string;
};

export const usePayrollExpenseFormAnalyticIds = (): PayrollExpenseFormAnalyticIds => ({
  ticketingProviderUsersAnalyticId: useAnalyticId(
    AnalyticIdentifier.ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_GENERAL_FORM_LINKED_TICKETING,
  ),
  nameAnalyticId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_GENERAL_FORM_NAME),
});
